import { h, Component } from 'preact';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { actionHandler, stepHasRequiredData, changeFocusOnMaxLength, isLoadingOnField } from '../../../utilities/form/formUtils';
import { setTrygTealium } from '../../../utilities/tracking';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import Error from '../../Form/Error';
import { replaceAll, replaceData } from '../../../utilities/common';

class InputText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: Object.hasOwnProperty.call(props.values, props.id) ? props.values[props.id] : '',
    };

    this.handleTextChange = this.handleTextChange.bind(this);
  }

  genetiveTextCheck(text) {
    let genetiveText;
    const lastChar = text.substring(text.length, text.length - 1);
    if (lastChar === 's' || lastChar === 'x' || lastChar === 'z') {
      genetiveText = `${text}'`;
    } else {
      genetiveText = `${text}s`;
    }
    return genetiveText;
  }

  updateGenetiveText(id, value, setFieldValue) {
    setFieldValue(`${id}-genetive`, this.genetiveTextCheck(value));
  }
  handleTextChange(event) {
    const {
      onChange,
      onBlur,
      maxLength,
      formValues,
      formValuesTemplate,
      actions,
      dispatch,
      values,
      setValues,
      tealiumMap,
      setFieldValue,
      genetiveCase,
      id,
    } = this.props;
    const { target: { value } } = event;

    if (tealiumMap) {
      const trackingData = {
        [tealiumMap]: value,
      };
      setTrygTealium(trackingData);
    }

    // Forces onBlur to save data, when value.length is equal to it's maxLength
    if (maxLength && value.length === Number(maxLength)) {
      onBlur(event, formValues, formValuesTemplate);
    }

    this.setState({
      value,
    });
    if (genetiveCase) {
      this.updateGenetiveText(id, value, setFieldValue);
    }
    // Handle actions on input.
    if (actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  render() {
    const {
      id,
      desc,
      label,
      placeholder,
      type,
      onBlur,
      errors,
      touched,
      required,
      columns,
      mobileColumns,
      maxLength,
      endFocus,
      formValues,
      formValuesTemplate,
      loadingOnField,
      translations,
      userData,
      value,
      values,
      requiredData,
    } = this.props;
    const isDisabled = !stepHasRequiredData(requiredData, userData, values);
    let newValue = this.state.value;
    if (value) {
      // This is fix if the next step is a text component (like previous step) as well
      // the id won't get updated. (so add a value to fix this)
      newValue = replaceData(value, values, false, false, false, true);
    }
    const isLoading = loadingOnField ? isLoadingOnField(loadingOnField, userData) : null;

    const formFieldClass = classNames(
      'form__field',
      'form__field--textfield', {
        'form__field is-disabled': isDisabled,
        'form__field--no-label': !label,
        [`form__field--${id}`]: id,
        [`form__field--${columns}col`]: columns,
        [`form__field--mobile-${mobileColumns}col`]: mobileColumns,
      },
      isLoading
    );

    const onTextBlur = (event) => {
      // Pass props needed for on blur event.
      onBlur(event, formValues, formValuesTemplate);
    };

    return (
      <div className={formFieldClass}>

        {/* Label */}
        {label &&
        <Label id={id} label={label}/>
        }

        {/* Input Field */}
        <input
          className="form__item"
          type={type}
          id={id}
          name={id}
          disabled={isDisabled}
          placeholder={replaceAll(placeholder, translations, formValues)}
          onChange={this.handleTextChange}
          onInput={event => changeFocusOnMaxLength(
            event,
            endFocus,
            maxLength,
            this.handleTextChange
          )}
          onKeyPress={e => {
            if (e.key === 'Enter') e.preventDefault();
          }}
          onBlur={onTextBlur}
          required={required}
          maxLength={maxLength}
          endFocus={endFocus}
          value={newValue}
        />

        {/* Error Message */}
        <Error touched={touched} errors={errors} id={id}/>

        {/* Description */}
        {desc &&
        <Description desc={desc}/>
        }
      </div>
    );
  }
}

export default compose(
  connect((state) => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;

    return {
      translations,
    };
  })
)(InputText);

InputText.defaultProps = {
  required: false,
  placeholder: null,
  desc: null,
  label: null,
  maxLength: null,
  endFocus: null,
  mobileColumns: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  tealiumMap: null,
  loadingOnField: '',
  value: null,
  genetiveCase: false,
  requiredData: null,
};

InputText.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.string,
  endFocus: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  values: PropTypes.array.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  tealiumMap: PropTypes.string,
  translations: PropTypes.object.isRequired,
  loadingOnField: PropTypes.string,
  userData: PropTypes.object.isRequired,
  value: PropTypes.string,
  genetiveCase: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  requiredData: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Input/Text.jsx